<template >
  <!-- About Start -->
    <section id="about" class="about" >
      <div class="about-decor">
        <div class="about-circle1"><img :src='"../../assets/images/team1-blue.png"' alt="team1"></div>
        <div class="about-circle2"><img :src='"../../assets/images/main-banner1-blue.png"' alt="banner1"></div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-md-5">
            <div class="about-contain">
              <div>
                <h2 class="title" style="margin-top: 32px">{{ $t("company.about.nav") }} <span>{{ $t("company.about.nav1") }}</span></h2>
<!--                <p class="caption-about">TOVO is dynamic, high-performance and easy to use landing page theme. The theme is developed focusing on the attractive designs and easy customizable features.</p>-->
                <div class="row sm-mb">
                  <div class="col">
                    <ul class="about-style">
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/time.png"' alt="easy-to-customized">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text1") }}</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/partners.png"' alt="easy-to-use">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text2") }}</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/banks.png"' alt="easy-to-use">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text3") }}</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/fin.png"' alt="easy-to-customized">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text4") }}</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/sp.png"' alt="easy-to-use">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text5") }}</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../../assets/images/company/it.png"' alt="easy-to-use">
                          </div>
                        </div>
                        <div class="about-text textMobile">
                          <h3>{{ $t("company.about.text6") }}</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="top-margin">
                  <a href="#recall" role="button" class="btn btn-custom theme-color theme-color">{{ $t("company.about.button") }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-medium-none">
            <div class="about-right">
              <div class="about-phone">
                <img :src='"../../assets/images/mediamodifier_image_2.png"' class="img-fluid" alt="aboutus">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About End -->

</template>
<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
export default defineComponent({
  name:'About',
  setup() {
    return {
      ...useI18n()
    }
  },
  methods: {
    SetLocale(locale) {
      console.log(locale);
      this.$i18n.locale = locale;
    },

  },
})
</script>
<style scoped>
  @media only screen and (min-width: 1600px) {
    .img-fluid {
      max-width: 700px;
    }
  }
  @media only screen and (max-width: 768px) {
    .textMobile {
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/companyPage/company_about.vue